import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./ArticleManage.module.css";

const ArticleManage = () => {
  const [articles, setArticles] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("adminAccessToken");

  useEffect(() => {
    fetch("/api/blogs/")
      .then((res) => res.json())
      .then(setArticles)
      .catch((err) => console.error("Failed to load articles", err));
  }, []);

  const handleDelete = (slug) => {
    if (!window.confirm("Are you sure you want to delete this article?")) return;

    fetch(`/api/admin/delete-blog/${slug}/`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to delete");
        return res.json();
      })
      .then(() => {
        setArticles((prev) => prev.filter((article) => article.slug !== slug));
      })
      .catch((err) => {
        alert("Failed to delete article");
        console.error(err);
      });
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Manage Articles</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.articleTable}>
          <thead>
            <tr>
              <th>Title</th>
              <th>Category</th>
              <th>Excerpt</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {articles.map((article) => (
              <tr
                key={article.slug}
                className={styles.tableRow}
                onClick={() => navigate(`/admin/article-edit/${article.slug}`)}
              >
                <td>{article.title}</td>
                <td>{article.category}</td>
                <td>{article.excerpt}</td>
                <td>
                  <button
                    className={styles.deleteButton}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(article.slug);
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ArticleManage;
